module.exports = __webpack_public_path__ + "static/media/MRL.a314e7b2.png";